import { Event, EventAttendeeState, Result } from '@/classes'
import { fetchAPI } from '@/utils/useAPI'
import { eventAttendAPI, eventAttendCancelAPI, eventAttendSetAPI, eventRoleSetAPI, eventReviewAPI } from '@/api/event'
import { useStore } from '@/utils/useStore'

import ToastsStore from '@/store/toasts'

export default defineStore('events', () => {
  const { getItem, getItems, setItem, deleteItem, updateItem } = useStore('event', {
    indexes: ['slug'],
    expiration: 60
  })

  const toastsStore = ToastsStore()

  const create = async (params: any, _id?: string) => {
    const response: Result<Event> = await fetchAPI('event/create', {
      params, _id
    }, { method: 'POST' })

    if (!response.ok || !response.data) {
      toastsStore.error(response)
      return response
    }

    const createdItem = response.data
    setItem(createdItem, { priority: 5 })

    toastsStore.add({ content: useNuxtApp().$i18n.t('common.editSuccess') })

    return {
      ok: true,
      data: new Event(createdItem)
    }
  }

  const attend = async (params: {
    event: string
    guests?: number
  }) => {
    const response = await eventAttendAPI(params)
    if (!response.ok || !response.data) return toastsStore.error(response)

    const updatedEvent = response.data.event
    setItem(updatedEvent, { priority: 5 })

    return {
      ok: true,
      data: {
        event: new Event(response.data.event)
      }
    }
  }

  const attendCancel = async (event: string) => {
    const response = await eventAttendCancelAPI({ event })
    if (!response.ok || !response.data) return toastsStore.error(response)

    const updatedEvent = response.data.event
    setItem(updatedEvent, { priority: 5 })

    return {
      ok: true,
      data: {
        event: new Event(response.data.event)
      }
    }
  }

  const attendSet = async (
    event: string,
    params: { [key: string ]: typeof EventAttendeeState[number] },
    options?: {
      validationCount?: number
    }
  ) => {
    const response = await eventAttendSetAPI(event, params, options)
    if (!response.ok || !response.data) return toastsStore.error(response)

    const updatedEvent = response.data.event
    setItem(updatedEvent, { priority: 5 })

    return {
      ok: true,
      data: {
        event: new Event(response.data.event)
      }
    }
  }

  const roleSet = async (
    userId: string,
    eventId: string,
    role: 'organizer' | 'attendee'
  ) => {
    const response = await eventRoleSetAPI(userId, eventId, role)
    if (!response.ok || !response.data) return toastsStore.error(response)

    const updatedEvent = response.data.event
    setItem(updatedEvent, { priority: 5 })

    return {
      ok: true,
      data: {
        event: new Event(response.data.event)
      }
    }
  }

  const review = async (
    eventId: string,
    params: {
      kudos: string[], tags: string[]
    }
  ) => {
    const response = await eventReviewAPI(eventId, params)
    if (!response.ok || !response.data) return toastsStore.error(response)

    const updatedEvent = response.data.event
    setItem(updatedEvent, { priority: 5 })

    return {
      ok: true,
      data: {
        event: new Event(response.data.event)
      }
    }
  }

  return {
    setItem, deleteItem,
 
    attend, attendCancel, attendSet, roleSet, review,
    getItems, getItem, fetch, create, updateItem
  }
})